import { render } from "./CourseDetailsPage.vue?vue&type=template&id=7c6a80cf&ts=true"
import script from "./CourseDetailsPage.vue?vue&type=script&lang=ts"
export * from "./CourseDetailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__